import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
export function isDef(val) {
  return val !== undefined && val !== null;
}
export function isKorean(text) {
  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}